import { render } from "./ViewFiles.vue?vue&type=template&id=28541f17&scoped=true&lang=pug"
import script from "./ViewFiles.vue?vue&type=script&lang=js"
export * from "./ViewFiles.vue?vue&type=script&lang=js"

import "./ViewFiles.vue?vue&type=style&index=0&id=28541f17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28541f17"]])

export default __exports__